import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import { toast } from "react-toastify";
import { obstructionArea, setLatlng, setProjectName, showEsriDrawTool } from "../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { setPolygonDrawn, setTitle, toggleDrawer } from "../../ReduxTool/Slice/Drawer/DrawerReducer";
import { setInformationModal, setIsBuildingDrawn, setOpenDraw, setToolTipModal, toggleMapModal } from "../../ReduxTool/Slice/Map/MapReducer";
import { store } from "../../ReduxTool/store/store";
import globalLayers from "../../Utils/CustomerMaps/Maps/GlobaLMap";
import { getsimpleFillSymbol } from "../../Utils/CustomerMaps/MarkerSymbols/MarkerSymbols";
import Graphic from "@arcgis/core/Graphic";
import { MAXUSEABLEAREA, MINUSEABLEAREA } from "../../Utils/Const";
import { handlePolygonDrawClick } from "../../Utils/handlePolygonDrawClick";
import { removeSearchedGraphic } from "../../Utils/CustomerMaps/Maps/removeSearchedLocationGraphic";
import { disableSearchWidget } from "../widget/Search/disableSearchWidget";
import { Polygon } from "@arcgis/core/geometry";

/**
 * The function `handlePolygonCreate` handles the creation of a polygon graphic on a map and calculates
 * its geodesic area.
 * @param {__esri.SketchCreateEvent} event - The `event` parameter is an object that represents the event that triggered the
 * function. It contains information about the event, such as the graphic that was created.
 * @param geometryEngine - The `geometryEngine` parameter is an object that provides various geometric
 * operations and calculations, such as measuring distances, areas, and performing spatial analysis. It
 * is typically provided by the ArcGIS API for JavaScript.
 * @param {string} titleName - The `titleName` parameter is a string that represents the title of the
 * graphic. It is used to set the `title` property of the `event.graphic` object.
 */
export const handlePolygonCreate = (event:any /*__esri.SketchCreateEvent | __esri.SketchUpdateEvent*/, geometryEngine: __esri.geometryEngine, titleName: string) => {
    store.dispatch(toggleMapModal(true))
    store.dispatch(setOpenDraw(false))
    
    let graphic: Graphic = event.graphic ? event.graphic : (event.graphics && event.graphics.length>0)?event.graphics[0] : {};
    if(!graphic) return;
    store.dispatch(setLatlng({ lat: (graphic.geometry as Polygon)?.centroid.latitude, lng: (graphic.geometry as Polygon)?.centroid.longitude }))
    if (graphic.geometry && geometryEngine) {
        try {
            (graphic as Graphic).setAttribute('name', 'building' + Math.random()* 100)
            graphic.symbol = new SimpleFillSymbol(
                getsimpleFillSymbol([173, 150, 50, 0.5], [150, 55, 0])
            )
            
        } catch (error) {
            console.log(error)
        }
  
        const geodesicArea = geometryEngine.geodesicArea((graphic.geometry as Polygon), "square-meters");
        const area = geodesicArea.toFixed(2)


        if(parseFloat(area)>MINUSEABLEAREA&&parseFloat(area)<MAXUSEABLEAREA){
            // store.dispatch(setToolTipModal({ state: true, title: "Precise Analysis", content: "Let's work together to find the perfect solar solution for your home! To proceed, please fill out all details on the left." }))
            store.dispatch(setInformationModal({state:true,title:"Precise Analysis",content:"Let's work together to find the perfect solar solution for your home! To proceed, please fill out all details on the left."}))            
            store.dispatch(setTitle("projectsetup"))
            store.dispatch(toggleDrawer(true))
            store.dispatch(obstructionArea({ obsArea: area }))
            
            globalLayers.totalroofArea = parseFloat(area);
            store.dispatch(showEsriDrawTool(false))
            store.dispatch(setPolygonDrawn('1'))
            store.dispatch(setIsBuildingDrawn(true))
            globalLayers.isBuildingThere = true
            disableSearchWidget(true)
            const projects = store.getState().consumerReducers.projects;
            store.dispatch(setProjectName(`PvNxtFP0${(projects && projects.length)?projects.length+1:1}`))
        }
        else{

            if (parseFloat(area)<MINUSEABLEAREA){
                store.dispatch(setInformationModal({state:true,title:"Building Too Small for Solar!",content:`The drawn area must be between ${MINUSEABLEAREA} sq m and ${MAXUSEABLEAREA} sq m.`,informationModalType:"warning"}))
            }
            else{
                store.dispatch(setInformationModal({state:true,title:"Solar Dream Too Big!",content:`Please draw a smaller roof area, under ${MAXUSEABLEAREA} sq. meters. Let's keep it cosmically cool! 🚀`,informationModalType:"warning"}))
            }
            globalLayers.tempgraphic = event.graphic
          
 
           
            
            setTimeout(()=>{
                globalLayers.lastactiveTool = 'polygon'

                store.dispatch(setToolTipModal({ state: true, title: "Drawing Mode", content: `Click points on the map to draw an area of interest. Press ESC to cancel the drawing mode.` })) 
                store.dispatch(setTitle(""))
                store.dispatch(toggleDrawer(false))   
                store.dispatch(setPolygonDrawn('0'))  
                globalLayers.removePolyLineswithTitle('')

                globalLayers.sketchVM.create("polygon");
                globalLayers.height = 0
                removeSearchedGraphic()
                
            },1500) 
            store.dispatch(setIsBuildingDrawn(false))         
        }

    } else {
        console.error("Unable to calculate geodesic area. Invalid graphic geometry or missing geometryEngine.");
        store.dispatch(setIsBuildingDrawn(false))
        globalLayers.isBuildingThere = false
    }
}